module.exports = __webpack_public_path__ + "static/media/doc-8.588050fa.jpg";